export default __webpack_public_path__ + "static/media/242254323_4244528972309069_845044139586773574_n@2x.788a1ef5.png";